module.exports = __webpack_public_path__ + "media/images/city/047-ming-dynasty-tombs-e4334da5947415c5db5641378382d9c5.svg";